import * as Dialog from '@radix-ui/react-dialog';
import { KeyboardEvent, ReactNode } from 'react';

import { dialogVariants } from '@/styles/dialog';

import { classNames } from '../../utils/classnames';
import { Overlay } from '../Dialog';
import styles from './styles.module.css';

export interface ModalProps {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  onOpenChange?: (newState: boolean) => void;
  className?: string;
  onOpenAutoFocus?: (event: Event) => void;
}

interface Props extends ModalProps {
  variant?:
    | 'DEFAULT'
    | 'MEDIUM'
    | 'LARGE'
    | 'XLARGE'
    | 'DEFAULT_BOTTOM_PANEL'
    | 'LARGE_BOTTOM_PANEL';
}

export const Modal = ({
  children,
  isOpen,
  onClose,
  onOpenChange,
  variant = 'DEFAULT',
  className,
  onOpenAutoFocus,
}: Props) => {
  function handleKeyEscape(e: KeyboardEvent<HTMLDivElement>) {
    if (e.key === 'Escape') onClose();
  }

  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(open) => {
        onOpenChange?.(open);
        if (!open) {
          onClose();
        }
      }}
    >
      <Dialog.Portal>
        <Overlay>
          <Dialog.Content
            className={classNames(dialogVariants[variant](), styles.animatedDialog, className)}
            onKeyDown={handleKeyEscape}
            onOpenAutoFocus={onOpenAutoFocus}
            onInteractOutside={(e) => {
              // check if a parent of the target has the `data-type` of `toast`
              if ((e.target as HTMLElement).closest('[data-type="toast"]')) {
                e.preventDefault();
                e.stopPropagation();
                return;
              }
            }}
            onPointerDownOutside={(e) => {
              // check if the target has a `data-type` of `toast`
              if ((e.target as HTMLElement).closest('[data-type="toast"]')) {
                e.preventDefault();
                e.stopPropagation();
                return;
              }
            }}
            forceMount
          >
            {children}
          </Dialog.Content>
        </Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
